import { Add, Close, Edit } from '@mui/icons-material';
import { Autocomplete, Button, FormControl, IconButton, Modal, Table, TableBody, TableCell, TableHead, TableRow, TextField } from '@mui/material';
import { Row } from 'antd';
import Loading from 'components/Loading';
import LoadingWrapper from 'components/LoadingWrapper';
import SelectableBookByGroup from 'components/SelectBookByGroup';
import { get, map } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { handleListGoogleCourse, handleUpdateGoogleCources } from 'store/booksUnits/thunks';
import { useDistricts } from 'store/organizations/selectors';
import styled from 'styled-components';
import COLOR from 'utils/constants/color';
const Wrapper = styled.div`
	height: 100%;
	width: 100%;
`;
const ModalContent = styled.div`
    align-items: center;
    background-color: ${COLOR.white};
    border-radius: 3px;
    display: inline-flex;
    flex-direction: column;
    left: 50%;
    width:90vw;
    height:90vh;
    padding: 16px;
    position: absolute;
    text-align: center;
    top: 50%;
    transform: translate(-50%, -50%);
`;
const ModalSection =  styled.div`
    background-color: ${COLOR.white};
    display: inline-flex;
    flex-direction: column;
    width:90vw;
    height:100%;
    overflow:auto;
    padding: 16px;
`;

const CourseUpdate = ({ openEditModal, setOpenEditModal, selectedData , onUpdate}) => {
    const [courseName, setCourseName] = useState(get(selectedData, 'displayName', ''))
    const [courseBooksByGroup, setCourseBooksByGroup] = useState([])
    const [orgId,setOrgId] = useState(get(selectedData, 'orgId', ''))
    const [loader, setLoader] = useState(null)
    const all_district = useDistricts()

    useEffect(() => {
        if (selectedData) {
            setCourseName(get(selectedData, 'displayName', ''))
            const books_group = get(selectedData, 'books_group', []) || []
            setOrgId(get(selectedData, 'orgId', ''))
            setCourseBooksByGroup(books_group)
        }
    }, [selectedData])
    const dispatch = useDispatch()

    const onCourseUpdate = async () => {
        const data = {
            id: get(selectedData, "id"),
            displayName: courseName,
            books_group: courseBooksByGroup,
            orgId: orgId
        }
        setLoader(true)
        await dispatch(handleUpdateGoogleCources(data))
        if(onUpdate){
            onUpdate()
        }
        setLoader(false)
        setOpenEditModal(false)
    }
    return (
        <Modal open={openEditModal} onClose={() => setOpenEditModal(false)}>
            <ModalContent>
                <Row style={{ justifyContent: "flex-end", width: "100%" }}>
                    <IconButton
                        onClick={e => setOpenEditModal(false)}
                        style={{ padding: 0, marginRight: 10 }}
                    >
                        <Close color="secondary" />
                    </IconButton>
                </Row>
                <h2>{selectedData?.id ? "Update Course" : "Add Course"}</h2>
                <Row style={{ width: "100%" }}>
                    <TextField value={courseName}  onChange={(e) => setCourseName(e.target.value)} label="District" variant="outlined" style={{ maxWidth: 400 }} />
                </Row>
                <Row style={{ width: "100%" }}>
                    <FormControl variant="outlined" style={{ width: 400, marginTop: 12 }}>
                        <Autocomplete
                            id="orgId"
                            options={all_district || []}
                            getOptionLabel={(option) => option.displayName || ""}
                            value={all_district.find(district => district.id === orgId) || null}
                            onChange={(event, newValue) => {
                                setOrgId(newValue ? newValue.id : null);
                            }}
                            style={{ height:40 }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Select Organization"
                                    variant="outlined"
                                />
                            )}
                        />
                    </FormControl>
                </Row>
                <ModalSection>
                    <SelectableBookByGroup
                        books_group={courseBooksByGroup}
                        onSelect={(item) => {
                            setCourseBooksByGroup(item)
                        }} />
                </ModalSection>
                <Row style={{ width: "100%", marginTop: 20 , justifyContent:"flex-end"}}>
                    <Button variant="contained" color="primary" onClick={onCourseUpdate}>{loader?<Loading size={14} white/>:null} {selectedData && selectedData.id ? "Update" : "Create"}</Button>
                </Row>
            </ModalContent>
        </Modal>
    )
}







export default function GoogleCourseMap() {
    const [courseList,setCourseList] = useState([])
    const [loading , setLoading] = useState(false)
    const [openEditModal, setOpenEditModal] = useState(false);
    const [selectedData, setSelectedData] = useState(null);
    const dispatch = useDispatch()
    async function fetchdata() {
        setLoading(true)
        const data = await dispatch(handleListGoogleCourse())
        if (data && data.success) {
            setCourseList(get(data, 'data', []))
        }
        setLoading(false)
    }
    useEffect(() => {
        fetchdata()
    }, [])
    const onEdit = (data) => {
        setSelectedData(data)
        setOpenEditModal(true)
    }
  return (
   <>
        <CourseUpdate openEditModal={openEditModal} selectedData={selectedData} setOpenEditModal={setOpenEditModal} onUpdate={fetchdata}  />
          <Wrapper>
          <Button variant="contained" color="primary" onClick={()=>onEdit({})}><Add/> Add Course</Button>
              <LoadingWrapper loading={loading}>
                  {courseList.length > 0 ? <Table style={{ width: "100%", textAlign: "center" }}>
                      <TableHead>
                          <TableRow>
                              <TableCell style={{ textAlign: "center" }}>District</TableCell>
                              <TableCell style={{ textAlign: "center" }}>Number of books</TableCell>
                              <TableCell style={{ textAlign: "center" }}>Edit</TableCell>
                          </TableRow>
                      </TableHead>
                      <TableBody>
                          {map(courseList, cuser => {
                              return (<>
                                  <TableRow key={cuser.id}>
                                      <TableCell style={{ textAlign: "center" }}>{get(cuser, "displayName", '')}</TableCell>
                                      <TableCell style={{ textAlign: "center" }}>{get(cuser, "books.length", '')}</TableCell>
                                      <TableCell style={{ textAlign: "center" }}><Button style={{ width: 85, height: 35 }} variant="text" onClick={()=>onEdit(cuser)} > <Edit style={{ color: COLOR.green }} /> </Button></TableCell>
                                  </TableRow>
                              </>)
                          })}
                      </TableBody>
                  </Table> : null}
              </LoadingWrapper>
          </Wrapper>
   </>
  )
}
